export const SET_USER = "USERS/SET_USER";
export const SET_USERS = "USERS/SET_USERS";
export const SET_ROLES = "ROLES/SET_ROLES";
export const SET_PAGINATION = "USERS/SET_PAGINATION";
